import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-subfamily',
  templateUrl: './item-subfamily.component.html',
  styleUrls: []
})
export class ItemSubFamiliaComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/subfamilia/item-subfamily.component.ts